import React, {useState, useEffect} from 'react';
import styles from '../styles/header.scss';
import {Link, useLocation} from "react-router-dom";


export const Header = props => {
    return (
        <div className={styles.headerContainer}>
            <div className={styles.paddingItem}/>

            <Link className={resolveClassName("/")} to={"/"}>Home</Link>
            <Link className={resolveClassName("/cv")} to={"/cv"}>Bio</Link>
            <Link className={resolveClassName("/portfolio")} to={"/portfolio"}>Portfolio</Link>
            <Link className={resolveClassName("/skills")} to={"/skills"}>Skills</Link>
            {/*<Link className={resolveClassName("/blog")} to={"/blog"}>Blog</Link>*/}

            <div className={styles.paddingItem}/>
        </div>
    )

    function resolveClassName(path) {
        const location = useLocation();

        let className = styles.headerItem;
        if (path === location.pathname) {
            className += " " + styles.headerItemActive;
        }

        return className;
    }
};